import script from "./ImportUploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportUploadFile.vue?vue&type=script&setup=true&lang=js"

import "./ImportUploadFile.vue?vue&type=style&index=0&id=6fac3f0a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fac3f0a"]])

export default __exports__